// The syntax highlighter the app renders code with (#12239).
//
// The full `Prism` export of react-syntax-highlighter registers every refractor
// grammar, about 300 of them, and all of them landed in the entry chunk. The
// light build carries only the grammars registered here. A fence or file in a
// language that is not registered still renders, in the same box, as plain
// text, which is what an unknown language did before. Each grammar module
// registers the grammars it extends (tsx pulls in jsx and typescript), and its
// aliases come with it (`py`, `js`, `ts`, `yml`, `shell`, `html`, `xml`, ...).
//
// Import from this module only. Importing `Prism` from the package anywhere
// in the app brings every grammar back into the bundle.
// Brings in the package's type declarations, which declare every deep path
// below; nothing imports the package root at runtime any more.
/// <reference types="react-syntax-highlighter" />
import PrismLight from "react-syntax-highlighter/dist/esm/prism-light";
import bash from "react-syntax-highlighter/dist/esm/languages/prism/bash";
import c from "react-syntax-highlighter/dist/esm/languages/prism/c";
import cpp from "react-syntax-highlighter/dist/esm/languages/prism/cpp";
import csharp from "react-syntax-highlighter/dist/esm/languages/prism/csharp";
import css from "react-syntax-highlighter/dist/esm/languages/prism/css";
import diff from "react-syntax-highlighter/dist/esm/languages/prism/diff";
import docker from "react-syntax-highlighter/dist/esm/languages/prism/docker";
import go from "react-syntax-highlighter/dist/esm/languages/prism/go";
import ini from "react-syntax-highlighter/dist/esm/languages/prism/ini";
import java from "react-syntax-highlighter/dist/esm/languages/prism/java";
import javascript from "react-syntax-highlighter/dist/esm/languages/prism/javascript";
import json from "react-syntax-highlighter/dist/esm/languages/prism/json";
import jsx from "react-syntax-highlighter/dist/esm/languages/prism/jsx";
import kotlin from "react-syntax-highlighter/dist/esm/languages/prism/kotlin";
import latex from "react-syntax-highlighter/dist/esm/languages/prism/latex";
import lua from "react-syntax-highlighter/dist/esm/languages/prism/lua";
import makefile from "react-syntax-highlighter/dist/esm/languages/prism/makefile";
import markdown from "react-syntax-highlighter/dist/esm/languages/prism/markdown";
import markup from "react-syntax-highlighter/dist/esm/languages/prism/markup";
import perl from "react-syntax-highlighter/dist/esm/languages/prism/perl";
import php from "react-syntax-highlighter/dist/esm/languages/prism/php";
import powershell from "react-syntax-highlighter/dist/esm/languages/prism/powershell";
import python from "react-syntax-highlighter/dist/esm/languages/prism/python";
import r from "react-syntax-highlighter/dist/esm/languages/prism/r";
import ruby from "react-syntax-highlighter/dist/esm/languages/prism/ruby";
import rust from "react-syntax-highlighter/dist/esm/languages/prism/rust";
import scala from "react-syntax-highlighter/dist/esm/languages/prism/scala";
import scss from "react-syntax-highlighter/dist/esm/languages/prism/scss";
import sql from "react-syntax-highlighter/dist/esm/languages/prism/sql";
import swift from "react-syntax-highlighter/dist/esm/languages/prism/swift";
import toml from "react-syntax-highlighter/dist/esm/languages/prism/toml";
import tsx from "react-syntax-highlighter/dist/esm/languages/prism/tsx";
import typescript from "react-syntax-highlighter/dist/esm/languages/prism/typescript";
import yaml from "react-syntax-highlighter/dist/esm/languages/prism/yaml";

// Keyed by the name a fence or `CodeFileView`'s extension map passes. The
// registration itself happens once, when this module is first imported, and
// only fills in the highlighter's grammar table: nothing is started.
const LANGUAGES: Record<string, unknown> = {
  markup,
  css,
  scss,
  javascript,
  jsx,
  typescript,
  tsx,
  python,
  r,
  sql,
  bash,
  json,
  yaml,
  toml,
  ini,
  markdown,
  docker,
  makefile,
  java,
  kotlin,
  c,
  cpp,
  go,
  rust,
  ruby,
  php,
  perl,
  swift,
  scala,
  lua,
  csharp,
  powershell,
  latex,
  diff,
};

for (const [name, grammar] of Object.entries(LANGUAGES)) {
  PrismLight.registerLanguage(name, grammar);
}

export { PrismLight };
